module.exports = __webpack_public_path__ + "static/media/level-1-anim.c1c48443.gif";